(function () {
  'use strict';

  var STORAGE_KEY = 'ww_recently_viewed_products_v1';
  var MAX_ITEMS = 24;

  function readRecentlyViewed() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (error) {
      return [];
    }
  }

  function writeRecentlyViewed(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_ITEMS)));
    } catch (error) {
      // Fail silently. Recently viewed should never break the storefront.
    }
  }

  function escapeHtml(value) {
    if (value === null || value === undefined) return '';

    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function parseCsv(value) {
    return String(value || '')
      .split(',')
      .map(function (item) {
        return normalize(item);
      })
      .filter(Boolean);
  }

  function formatMoney(value) {
    if (value === null || value === undefined || value === '') return '';

    if (typeof value === 'string' && value.indexOf('$') !== -1) {
      return value;
    }

    var cents = parseInt(value, 10);

    if (isNaN(cents)) {
      return '';
    }

    return '$' + (cents / 100).toFixed(2);
  }

  function getProductType(product) {
    return product.type || product.product_type || product.productType || '';
  }

  function getProductTags(product) {
    if (!product || !product.tags) return [];

    if (Array.isArray(product.tags)) {
      return product.tags.map(normalize);
    }

    if (typeof product.tags === 'string') {
      return parseCsv(product.tags);
    }

    return [];
  }

  function getImageFromRecommendation(product) {
    if (!product) return '';

    if (typeof product.featured_image === 'string') {
      return product.featured_image;
    }

    if (product.featured_image && product.featured_image.url) {
      return product.featured_image.url;
    }

    if (product.featured_image && product.featured_image.src) {
      return product.featured_image.src;
    }

    if (product.images && product.images.length) {
      if (typeof product.images[0] === 'string') {
        return product.images[0];
      }

      if (product.images[0].url) {
        return product.images[0].url;
      }

      if (product.images[0].src) {
        return product.images[0].src;
      }
    }

    return '';
  }

  function buildProductCard(item) {
    var title = escapeHtml(item.title);
    var url = escapeHtml(item.url || ('/products/' + item.handle));
    var image = escapeHtml(item.image || '');
    var price = escapeHtml(item.price || '');
    var type = escapeHtml(item.type || '');

    return [
      '<article class="ww-home-card">',
        '<a class="ww-home-card__link" href="' + url + '">',
          '<div class="ww-home-card__image-wrap">',
            image ? '<img class="ww-home-card__image" src="' + image + '" alt="' + title + '" loading="lazy">' : '<div class="ww-home-card__image-placeholder"></div>',
          '</div>',
          '<div class="ww-home-card__body">',
            '<h3 class="ww-home-card__title">' + title + '</h3>',
            type ? '<div class="ww-home-card__meta">' + type + '</div>' : '',
            price ? '<div class="ww-home-card__price">' + price + '</div>' : '',
          '</div>',
        '</a>',
      '</article>'
    ].join('');
  }

  function trackCurrentProductView() {
    var dataScript = document.getElementById('WWProductViewData');

    if (!dataScript) return;

    try {
      var product = JSON.parse(dataScript.textContent);

      if (!product || !product.handle || !product.id) return;

      var items = readRecentlyViewed();

      items = items.filter(function (item) {
        return String(item.handle) !== String(product.handle);
      });

      product.viewedAt = Date.now();

      items.unshift(product);

      writeRecentlyViewed(items);
    } catch (error) {
      // Fail silently.
    }
  }

  function getRelatedLaneSettings() {
    var defaults = {
      allowedProductTypes: [],
      excludedProductTypes: [],
      excludedTags: [],
      productsShown: 10,
      fallbackProducts: []
    };

    var settingsScript = document.getElementById('WWRelatedLaneSettings');

    if (!settingsScript) return defaults;

    try {
      var parsed = JSON.parse(settingsScript.textContent);

      return {
        allowedProductTypes: parseCsv(parsed.allowedProductTypes),
        excludedProductTypes: parseCsv(parsed.excludedProductTypes),
        excludedTags: parseCsv(parsed.excludedTags),
        productsShown: parseInt(parsed.productsShown, 10) || 10,
        fallbackProducts: Array.isArray(parsed.fallbackProducts) ? parsed.fallbackProducts : []
      };
    } catch (error) {
      return defaults;
    }
  }

  function productPassesRelatedFilters(product, settings) {
    var productType = normalize(getProductType(product));
    var tags = getProductTags(product);

    if (settings.allowedProductTypes.length && settings.allowedProductTypes.indexOf(productType) === -1) {
      return false;
    }

    if (settings.excludedProductTypes.length && settings.excludedProductTypes.indexOf(productType) !== -1) {
      return false;
    }

    if (settings.excludedTags.length) {
      for (var i = 0; i < tags.length; i++) {
        if (settings.excludedTags.indexOf(tags[i]) !== -1) {
          return false;
        }
      }
    }

    return true;
  }

  function normalizeRecommendationProduct(product) {
    return {
      id: product.id,
      handle: product.handle,
      title: product.title,
      url: product.url || ('/products/' + product.handle),
      image: getImageFromRecommendation(product),
      price: formatMoney(product.price),
      type: getProductType(product),
      tags: getProductTags(product)
    };
  }

  function uniqueByHandle(products) {
    var seen = {};
    var unique = [];

    products.forEach(function (product) {
      if (!product || !product.handle || seen[product.handle]) return;

      seen[product.handle] = true;
      unique.push(product);
    });

    return unique;
  }

  function renderRecentlyViewed(root) {
    var carousels = (root || document).querySelectorAll('[data-ww-recently-viewed-carousel]');

    if (!carousels.length) return;

    var items = readRecentlyViewed().slice(0, 12);

    carousels.forEach(function (carousel) {
      var section = carousel.closest('[data-ww-recently-viewed-section]');

      if (!items.length) {
        if (section) section.hidden = true;
        return;
      }

      carousel.innerHTML = items.map(buildProductCard).join('');

      if (section) section.hidden = false;
    });
  }

  function renderRelatedProducts(carousels, products, settings) {
    var finalProducts = uniqueByHandle(products)
      .filter(function (product) {
        return productPassesRelatedFilters(product, settings);
      })
      .slice(0, settings.productsShown);

    carousels.forEach(function (carousel) {
      var section = carousel.closest('[data-ww-related-section]');

      if (!finalProducts.length) {
        if (section) section.hidden = true;
        return;
      }

      carousel.innerHTML = finalProducts.map(buildProductCard).join('');

      if (section) section.hidden = false;
    });
  }

  function renderRelatedFromRecentlyViewed(root) {
    var carousels = (root || document).querySelectorAll('[data-ww-related-carousel]');

    if (!carousels.length) return;

    var settings = getRelatedLaneSettings();
    var recent = readRecentlyViewed();

    if (!recent.length || !recent[0].id) {
      carousels.forEach(function (carousel) {
        var section = carousel.closest('[data-ww-related-section]');
        if (section) section.hidden = true;
      });
      return;
    }

    var recentHandles = recent.map(function (item) {
      return item.handle;
    });

    var fallbackProducts = settings.fallbackProducts.filter(function (product) {
      return recentHandles.indexOf(product.handle) === -1;
    });

    var productId = recent[0].id;
    var rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';

    fetch(rootUrl + 'recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=10&intent=related')
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        var recommendedProducts = data && data.products ? data.products : [];

        recommendedProducts = recommendedProducts.map(normalizeRecommendationProduct);

        renderRelatedProducts(carousels, recommendedProducts.concat(fallbackProducts), settings);
      })
      .catch(function () {
        renderRelatedProducts(carousels, fallbackProducts, settings);
      });
  }

  function shuffleArray(items) {
    var array = items.slice();

    for (var i = array.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }

    return array;
  }

  function applyCollectionLaneDisplay(root) {
    var lanes = (root || document).querySelectorAll('.ww-home-lane[data-ww-products-shown]');

    lanes.forEach(function (lane) {
      var track = lane.querySelector('[data-ww-carousel-track]');
      var shouldShuffle = lane.getAttribute('data-ww-shuffle') === 'true';
      var productsShown = parseInt(lane.getAttribute('data-ww-products-shown'), 10);
      var cards = track ? Array.prototype.slice.call(track.children) : [];

      if (!track || !cards.length || isNaN(productsShown) || productsShown < 1) return;

      cards.forEach(function (card) {
        card.hidden = false;
      });

      if (shouldShuffle && cards.length > 1) {
        cards = shuffleArray(cards);

        cards.forEach(function (card) {
          track.appendChild(card);
        });
      }

      Array.prototype.slice.call(track.children).forEach(function (card, index) {
        if (index >= productsShown) {
          card.hidden = true;
        }
      });
    });
  }

  function bindCarouselControls(root) {
    var shells = (root || document).querySelectorAll('[data-ww-carousel]');

    shells.forEach(function (shell) {
      if (shell.dataset.wwCarouselBound === 'true') return;

      shell.dataset.wwCarouselBound = 'true';

      var track = shell.querySelector('[data-ww-carousel-track], [data-ww-recently-viewed-carousel], [data-ww-related-carousel]');
      var prev = shell.querySelector('[data-ww-carousel-prev]');
      var next = shell.querySelector('[data-ww-carousel-next]');

      if (!track || !prev || !next) return;

      prev.addEventListener('click', function () {
        track.scrollBy({
          left: -Math.max(280, track.clientWidth * 0.85),
          behavior: 'smooth'
        });
      });

      next.addEventListener('click', function () {
        track.scrollBy({
          left: Math.max(280, track.clientWidth * 0.85),
          behavior: 'smooth'
        });
      });
    });
  }

  function initPhaseOneHome(root) {
    renderRecentlyViewed(root);
    renderRelatedFromRecentlyViewed(root);
    applyCollectionLaneDisplay(root);
    bindCarouselControls(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    trackCurrentProductView();
    initPhaseOneHome(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initPhaseOneHome(event.target);
  });
})();